import React from "react";

function Evehicle({ productone, producttwo }) {
    console.log(productone)
    return (
        <div className="bg-white compare-specs rounded p-3">
            <h5>Engine and Performance</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Name</td>
                            <td className="bg-light text-danger fw-bold">{productone?.title}</td>
                            <td className="bg-light text-danger fw-bold">{producttwo?.title}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Engine Type</td>
                            <td >{productone?.engineperformance?.engine_type}</td>
                            <td >{producttwo?.engineperformance?.engine_type}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Engine Capacity</td>
                            <td >{productone?.engineperformance?.engine_capacity}</td>
                            <td >{producttwo?.engineperformance?.engine_capacity}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Power Output</td>
                            <td>{productone?.engineperformance?.power_output}</td>
                            <td>{producttwo?.engineperformance?.power_output}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Torque</td>
                            <td>{productone?.engineperformance?.torque}</td>
                            <td>{producttwo?.engineperformance?.torque}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Transmission</td>
                            <td>{productone?.engineperformance?.transmission}</td>
                            <td>{producttwo?.engineperformance?.transmission}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Fuel Efficiency</td>
                            <td>{productone?.engineperformance?.fuel_efficiency}</td>
                            <td>{producttwo?.engineperformance?.fuel_efficiency}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Acceleration (0-60 mph or 0-100 km/h)</td>
                            <td>{productone?.engineperformance?.acceleration}</td>
                            <td>{producttwo?.engineperformance?.acceleration}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5 className="mt-3">Dimensions & Weight</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Length</td>
                            <td>{productone?.diminsionweight?.length}</td>
                            <td>{producttwo?.diminsionweight?.length}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Width</td>
                            <td>{productone?.diminsionweight?.width}</td>
                            <td>{producttwo?.diminsionweight?.width}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Height</td>
                            <td>{productone?.diminsionweight?.height}</td>
                            <td>{producttwo?.diminsionweight?.height}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Wheelbase</td>
                            <td>{productone?.diminsionweight?.wheel_base}</td>
                            <td>{producttwo?.diminsionweight?.wheel_base}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Ground Clearance</td>
                            <td>{productone?.diminsionweight?.ground_clearance}</td>
                            <td>{producttwo?.diminsionweight?.ground_clearance}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Kerb Weight</td>
                            <td>{productone?.diminsionweight?.kerb_weight}</td>
                            <td>{producttwo?.diminsionweight?.kerb_weight}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Cargo Capacity</td>
                            <td>{productone?.diminsionweight?.cargo_capacity}</td>
                            <td>{producttwo?.diminsionweight?.cargo_capacity}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5 className="mt-3">Interior & Comfort</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Seating Capacity</td>
                            <td className="">{productone?.interiorcomfort?.seating_capacity}</td>
                            <td className="">{producttwo?.interiorcomfort?.seating_capacity}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Upholstery</td>
                            <td>{productone?.interiorcomfort?.upholstery}</td>
                            <td>{producttwo?.interiorcomfort?.upholstery}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Infotainment</td>
                            <td>{productone?.interiorcomfort?.infotainment}</td>
                            <td>{producttwo?.interiorcomfort?.infotainment}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Climate Control</td>
                            <td>{productone?.interiorcomfort?.climate_control}</td>
                            <td>{producttwo?.interiorcomfort?.climate_control}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Driver Assistance Features</td>
                            <td>{productone?.interiorcomfort?.driver_assistance_features}</td>
                            <td>{producttwo?.interiorcomfort?.driver_assistance_features}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5 className="mt-3">Safety Features</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Airbags</td>
                            <td className="">{productone?.safetyfeature?.airbags}</td>
                            <td className="">{producttwo?.safetyfeature?.airbags}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Braking System</td>
                            <td>{productone?.safetyfeature?.braking_system}</td>
                            <td>{producttwo?.safetyfeature?.braking_system}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Crash Test Rating</td>
                            <td>{productone?.safetyfeature?.crash_test_rating}</td>
                            <td>{producttwo?.safetyfeature?.crash_test_rating}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Security Features</td>
                            <td>{productone?.safetyfeature?.Security_features}</td>
                            <td>{producttwo?.safetyfeature?.Security_features}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5 className="mt-3">Exterior</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Headlights</td>
                            <td className="">{productone?.exterior?.headlights}</td>
                            <td className="">{producttwo?.exterior?.headlights}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Wheels/Tires</td>
                            <td>{productone?.exterior?.wheels_tires}</td>
                            <td>{producttwo?.exterior?.wheels_tires}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Sunroof/Convertible</td>
                            <td>{productone?.exterior?.sunroof}</td>
                            <td>{producttwo?.exterior?.sunroof}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Mirrors</td>
                            <td>{productone?.exterior?.mirrors}</td>
                            <td>{producttwo?.exterior?.mirrors}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Exterior Colors</td>
                            <td>{productone?.exterior?.exterior_colors}</td>
                            <td>{producttwo?.exterior?.exterior_colors}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5 className="mt-3">Technology & Connectivity</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Navigation System</td>
                            <td className="">{productone?.technologyconnectivity?.navigation_system}</td>
                            <td className="">{producttwo?.technologyconnectivity?.navigation_system}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Connectivity</td>
                            <td>{productone?.technologyconnectivity?.connectivity}</td>
                            <td>{producttwo?.technologyconnectivity?.connectivity}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Camera & Sensors</td>
                            <td>{productone?.technologyconnectivity?.camera_sensors}</td>
                            <td>{producttwo?.technologyconnectivity?.camera_sensors}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Keyless Entry</td>
                            <td>{productone?.technologyconnectivity?.keyless_entry}</td>
                            <td>{producttwo?.technologyconnectivity?.keyless_entry}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5 className="mt-3">Fuel & Charging (if applicable)</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Fuel Tank Capacity</td>
                            <td className="">{productone?.fuelcharging?.fuel_tank_capacity}</td>
                            <td className="">{producttwo?.fuelcharging?.fuel_tank_capacity}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Electric Range (for electric vehicles)</td>
                            <td>{productone?.fuelcharging?.electric_range}</td>
                            <td>{producttwo?.fuelcharging?.electric_range}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Charging Time (for electric vehicles)</td>
                            <td>{productone?.fuelcharging?.charging_time}</td>
                            <td>{producttwo?.fuelcharging?.charging_time}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Fuel Type</td>
                            <td>{productone?.fuelcharging?.fuel_type}</td>
                            <td>{producttwo?.fuelcharging?.fuel_type}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h5 className="mt-3">Warranty & Service</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Warranty</td>
                            <td className="">{productone?.warrantyservice?.warranty}</td>
                            <td className="">{producttwo?.warrantyservice?.warranty}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Service Intervals</td>
                            <td>{productone?.warrantyservice?.service_intervals}</td>
                            <td>{producttwo?.warrantyservice?.service_intervals}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
            <h5 className="mt-3">Additional Features</h5>
            <div style={{ overflow: 'scroll' }}>
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td className="text-start">Performance Enhancements</td>
                            <td className="">{productone?.additionalfeature?.performance_enhancements}</td>
                            <td className="">{producttwo?.additionalfeature?.performance_enhancements}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Customizations</td>
                            <td>{productone?.additionalfeature?.customizations}</td>
                            <td>{producttwo?.additionalfeature?.customizations}</td>
                        </tr>
                        <tr>
                            <td className="text-start">Special Editions</td>
                            <td>{productone?.additionalfeature?.special_editions}</td>
                            <td>{producttwo?.additionalfeature?.special_editions}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Evehicle;